import { Button, Grid, Card, CardHeader, Box } from "@mui/material";
import { FC, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Content } from "@/components/content/Content";
import { ClassificationRuleAmbinetDataCotnextProvider } from "@/components/securefiles/ClassificationRuleAmbientDataProvider";
import CreateOrEdit from "@/controller/CreateOrEdit";
import { useDefaultSavedHandlers } from "@/controller/defaultSavedHandlers";
import WithSave from "@/controller/WithSave";
import { OdResourcePageProps } from "@/types/resource";
import { push } from "connected-react-router";
import { DataClassificationRuleInput } from "@/gen/api/encrypt";
import DataClassificationRuleEdit from "@/components/obfuscation/ClassificationProtection/DataClassificationRuleEdit";
import { useLmStatesPropagate } from "@/contexts/LocalMessageHookProtocols/useLmStatesPropagate";
import { LocalMessageLocation, useLocalMessagingRoot } from "@/contexts/LocalMessagingRoot";
import { useLmGlobalDisabledMsg } from "@/contexts/LocalMessageHookProtocols/useLmGlobalDisabledMsg";


const CreateDataClassificationRule: FC<OdResourcePageProps> = (props) => {
  const handlers = useDefaultSavedHandlers("Create Data Classification Rule")

  return (
    <ClassificationRuleAmbinetDataCotnextProvider>
      <CreateOrEdit resource={props.resource} basePath="" {...handlers}>
        <CreateDataClassificationRuleBody {...props} />
      </CreateOrEdit>
    </ClassificationRuleAmbinetDataCotnextProvider>
  )
}

const CreateDataClassificationRuleBody: FC<OdResourcePageProps> = ({
  resource, options,
}) => {
  const [states, setStates] = useState({ dirty: false })
  const dispatch = useDispatch()
  
  const {LocalMessagingRootHost, subscribe, publish} = useLocalMessagingRoot()
  const {assembleSubStates} = useLmStatesPropagate({ 
    key: 'root',
    asUpperStage: {
      dirtyStateInformed: {
        handler() {
          return (_, dirty) => setStates(v => ({...v, dirty }))
        },
        deps: []
      }
    }
  }, {subscribe, publish})
  useLmGlobalDisabledMsg({ authority }, {subscribe, publish})

  const handleSave = (save: (record:any,callbacks?:any)=>void) => async () => {
    // if (!hasEditPermit) { return }
    if (!states.dirty) { return }
    
    try {
      const payload: DataClassificationRuleInput = (await assembleSubStates(['editor'])).editor
      
      save(payload, {
        onSuccess: () => {
          dispatch(push(`/${resource}`))
        }
      })
    } catch (error) {
      // validation must had failed
    }
  }
  
  return (
    <Content 
      pageName="Create Data Classification Rule" 
      resourceName="Create" 
      breadcrumbs={[...(options?.breadcrumbs ?? []), {
        label: 'Data Classification Rules',
        path: `/${resource}`
      }]}
      mainActions={
        <>
          <WithSave 
            render={({save, saving}) =>
              <Button
                color="primary"
                disabled={!states.dirty || saving}
                variant="contained"
                onClick={handleSave(save)}
              >
                Save
              </Button>}
          />
          <Button
            color="primary"
            variant="outlined"
            component={RouterLink}
            to={`/${resource}`}
          >
            Cancel
          </Button>
        </>
      }
    >
      <Grid container spacing={4} sx={{ mt: 2 }} >
        <Grid item xs={12}>
          <Card sx={{ minHeight: 600 }}>
            <CardHeader title="New Data Classification Rule" />
            <Box sx={{ mb: 2, px: 4, }}>
              <LocalMessagingRootHost>
                <LocalMessageLocation id="editor">
                  <DataClassificationRuleEdit />
                </LocalMessageLocation>
              </LocalMessagingRootHost>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Content>
  )
}

export default CreateDataClassificationRule;

const authority = () => Promise.resolve(false)